import { SharedService } from './../../../layouts/shared-service';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    Optional,
    Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomersEditComponent } from '../customers-edit/customers-edit.component';

@Component({
    selector: 'app-customers-edit-dialog',
    templateUrl: './customers-edit-dialog.component.html'
})
export class CustomersEditDialogComponent implements OnInit {
    @ViewChild(CustomersEditComponent) customersEditComponent: CustomersEditComponent;

    // For AppDialogWrapperService pattern
    @Output() dialogClosed = new EventEmitter<any>();
    @Output() cancelDialog = new EventEmitter<void>();

    @Input() customerInfoByGroupId: number;
    @Input() showCustomerDetailsTab: boolean = false;
    @Input() showPricingTab: boolean = false;
    @Input() title: string = "";
    updatedPricingData: any = null;

    // For backwards compatibility with direct MatDialog usage
    @Optional() public dialogRef?: any;
    private _data: any;
    
    get data(): any {
        return this._data;
    }
    
    set data(value: any) {
        this._data = value;
        if (value) {
            this.customerInfoByGroupId = value.customerInfoByGroupId;
            if (value.showCustomerDetailsTab != undefined && value.showCustomerDetailsTab != null)
                this.showCustomerDetailsTab = value.showCustomerDetailsTab;
            if (value.showPricingTab != undefined && value.showPricingTab != null)
                this.showPricingTab = value.showPricingTab;
            if (value.title != "")
                this.title = value.title + ' ';
        }
    }

    constructor(
        @Optional() @Inject(MatDialogRef) dialogRef?: MatDialogRef<any>,
        @Optional() @Inject(MAT_DIALOG_DATA) data?: any
    ) {
        // Backwards compatibility: support both injection patterns
        if (dialogRef) {
            this.dialogRef = dialogRef;
        }
        if (data) {
            this._data = data;
            this.customerInfoByGroupId = data.customerInfoByGroupId;
            if (data.showCustomerDetailsTab != undefined && data.showCustomerDetailsTab != null)
                this.showCustomerDetailsTab = data.showCustomerDetailsTab;
            if (data.showPricingTab != undefined && data.showPricingTab != null)
                this.showPricingTab = data.showPricingTab;
            if (data.title != "")
                this.title = data.title + ' ';
        }
    }

    ngOnInit() {
    }

    close() {
        const updatedData = (this.customersEditComponent as any)?.getCurrentPricingData();
        if (this.dialogRef) {
            // Direct MatDialog usage
            this.dialogRef.close(updatedData);
        } else {
            // AppDialogWrapperService usage
            this.dialogClosed.emit(updatedData);
        }
    }
}
